import _ from 'lodash'
// validators return an Result object
// {
//   valid: bool - whether argument passes validation
//   errors: [string] - reasons validation failed ([] if valid)
// }
class Result {
  constructor () {
    this.valid = true
    this.errors = []
  }

  validateRegEx (regex, arg, error) {
    if (!regex.test(arg)) {
      this.valid = false
      this.errors.push(error)
    }
  }

  validateFunc (func, arg, error) {
    if (!func(arg)) {
      this.valid = false
      this.errors.push(error)
    }
  }
}

export const VALID_EMAIL = 'Email must be valid'
export const USERNAME_LENGTH = 'Username must be at least 5 characters long'
export const USERNAME_CASE = 'Username must be lowercase'
export const VALID_PHONE = 'Phone number must 10 digits, optional "+1" prepended (e.g. 7804428341 or +18053791456)'
export const VALID_NPI = 'NPI must be 10 digits'
export const PASSWORD_CONTAINS_NUMBER = 'Password must contain at least one number (0-9)'
export const PASSWORD_CONTAINS_SPECIAL_CHAR = 'Password must contain at least one special character (e.g. !@#$%^&*)'
export const PASSWORD_CONTAINS_UPPERCASE = 'Password must contain at least one capital letter (A-Z)'
export const PASSWORD_LONG_ENOUGH = 'Password must be at least 10 characters long'
export const TWO_WORD_NAME = 'Name must contain a first and last name with exactly one space'
export const MUST_BE_NUMBER = 'Must be a positive number'
export const FAKE_EMAIL = 'Please do not use fake emails. Leave email blank if unknown'

export const validateEmail = (email, required = true) => {
  let result = new Result()
  if (!required && !email) {
    return result
  }
  const re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
  result.validateRegEx(re, String(email).toLowerCase(), VALID_EMAIL)
  const fakeEmails = [
    'na@gmail.com',
    'n/a@gmail.com',
    'fake@gmail.com',
  ]
  if (_.includes(fakeEmails, email)) {
    result.valid = false
    result.errors.push(FAKE_EMAIL)
  }
  return result
}

export const validateNumber = (number, required = true) => {
  let result = new Result()
  if (!required && !number) {
    return result
  }
  const parsedInteger = parseInt(number, 10)
  if (!parsedInteger || parsedInteger < 0) {
    result.valid = false
    result.errors.push(MUST_BE_NUMBER)
  }
  return result
}

export const validateUser = (userName) => {
  let result = new Result()
  if (userName.size < 5) {
    result.valid = false
    result.errors.push(USERNAME_LENGTH)
  }
  if (userName !== userName.toLowerCase()) {
    result.valid = false
    result.errors.push(USERNAME_CASE)
  }
  return result
}

export const validatePhoneNumber = (number) => {
  let result = new Result()
  const re = /^(\+1)?[2-9]{1}\d{9}$/
  result.validateRegEx(re, number, VALID_PHONE)
  return result
}

export const validateNPI = (npi) => {
  let result = new Result()
  const re = /^\d{10}$/
  result.validateRegEx(re, npi, VALID_NPI)
  return result
}

export const validatePassword = (password) => {
  let result = new Result()
  // Passwords must have:
  //     - a number
  result.validateRegEx(/\d/, password, PASSWORD_CONTAINS_NUMBER)
  //     - a special character
  result.validateRegEx(/\W/, password, PASSWORD_CONTAINS_SPECIAL_CHAR)
  //     - uppercase character
  result.validateRegEx(/[A-Z]/, password, PASSWORD_CONTAINS_UPPERCASE)
  //     - at least 10 characters
  const checkLength = (pass) => pass.length >= 10
  result.validateFunc(checkLength, password, PASSWORD_LONG_ENOUGH)
  return result
}

export const validatePrescriberName = (name) => {
  let result = new Result()
  const re = /^\S+ \S+$/
  result.validateRegEx(re, name, TWO_WORD_NAME)
  return result
}



// WEBPACK FOOTER //
// ./src/lib/validation.js